
import Header from '../components/layout/Header';

const Settings = () => {
  return (
    <div className="h-full flex flex-col bg-gray-50">
      <Header title="Settings" subtitle="Configure system settings" />
      
      <div className="flex-1 p-8 animate-fade-in">
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h2 className="text-2xl font-medium text-gray-700 mb-4">Settings Page</h2>
          <p className="text-gray-500">This is the settings page.</p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
